module.exports = __webpack_public_path__ + "de077a9a2a61ab573a4651dd7f470dcb.webp";